// @owners { team: patients }

// Same CloudFront distributions the web app already deploys through — see
// apps/web/bin/common.sh's getCdnUrlForEnv. Duplicated here (rather than a shared
// source of truth) since these domains are effectively permanent and only reachable
// from bash in that script; keep in sync if that infra ever changes.
const PROD_CDN_URL = 'https://d17ergeyp5gj5y.cloudfront.net';
const NON_PROD_CDN_URL = 'https://d3cuyjequulw.cloudfront.net';

type BackendEnvironment = 'local' | 'sandbox' | 'staging' | 'integration' | 'production';

// Path is intentionally not branch-namespaced (unlike the sandbox build-output convention) so
// it can be updated independently of any deploy.
export const getScheduledDowntimeUrl = (env: BackendEnvironment): string => {
  const cdnUrl = env === 'production' ? PROD_CDN_URL : NON_PROD_CDN_URL;
  const namespace = env === 'production' ? 'patient-app/prod' : 'patient-app/staging';
  return `${cdnUrl}/${namespace}/scheduled-downtime.json`;
};
